import { getRoomsState, getStateUser } from '../state/getState'

/**
 * Check if the current user is the room helper for a given model.
 */
export function isRoomHelper(modelId: number): boolean {
    return getStateUser(modelId)?.isRoomHelper === true
}

export function isGuestUsername(username: string): boolean {
    return /^guest\d+$/i.test(username)
}

export function resolveGuestSession(
    username: string,
    modelId: number,
): number | null {
    const { [modelId]: room } = getRoomsState()
    if (!room?.participants) return null

    const participant = room.participants.find(
        (p) => p.name?.toLowerCase() === username.toLowerCase(),
    )
    if (!participant) return null

    return getStateUser(participant.id)?.session ?? null
}
